export default "__VITE_ASSET__GbqCwt0E__"